module.exports = __webpack_public_path__ + "img/tray.428dfdd9.svg";